import axios from 'axios'

export default class Ticket {
  /**
   * 领取票券
   */
  getTicketNow (params) {
    return axios.post(`http://liansuo.i200.cn/member-coupons?couponRuleId=${params.couponRuleId}&channel=${params.channel}&phone=${params.phone}&name=${params.name}`, params).then(res => {
      return res.data
    })
  }

  /**
   * 获得优惠券详情
   */
  getTicketDetail (couponRuleId) {
    return axios.get(`http://liansuo.i200.cn/coupon-rules/single?couponRuleId=${couponRuleId}`).then(res => {
      return res.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/model/ticket/index.js